require("./hirePackOpenYoungStep1.scss");

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { PROC_PACK_OPEN_YOUNG } = require('utilities/tagging');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');

// @constants
const { FIRST_STEP } = require('constants/index');

// @ constants
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { OPEN_YOUNG_PACK_PRODUCT_ALIAS,
        PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');

class HirePackOpenYoungStep1 extends React.Component {
    componentDidMount() {
        const {
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['open_young_card_account_package'].preContractPdfLink;
            const productsList = [{
                type: '506',
                subtype: '010',
                standard: '0000001'
            },{
                type: '301',
                subtype: '101',
                standard: '0000001'
            }];
            requestPDFMerge(pdfurls, productsList);
        } else {
            setTermsAndCondsText('hirePackOpenYoung-hirePackOpenYoung_confirmationStepAgreementText');
        }
    }

     buildLegalConfirmationSection() {
        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');

        if (!__CONTACT_CENTER__ || !information) {
            return null;
        }

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHirePackOpenYoung,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendMailParams,
            sendPreContractualMail,
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const immStep = immHirePackOpenYoung.getIn([ 'steps', FIRST_STEP ]);
        const agreementLabel = <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_confirmationStepAgreementText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hirePackOpenYoung-hirePackOpenYoung_step5CheckboxErrorMsg');

        return (
            <section className="hire-card-openyoung-pack-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                />
                <div className="hire-card-openyoung-pack-step-one__checkbox-container">
                    <OKCheckbox
                        disabled={!hasBeenEmailSent}
                        errorMessage={agreementErrorMsg}
                        errorState={agreementErrorVisible}
                        idName="hireCardDiamondPackAgreementCheckbox"
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if(gestorCrossEnabled) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={OPEN_YOUNG_PACK_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    {legalConfirmationSection}
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-pack-open-young__step-one">
                    <FormattedText
                        className="hire-pack-open-young__step-title"
                        value="hirePackOpenYoung-hirePackOpenYoung_step1Title"
                    />
                    <HireInformation
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                        tealiumProcess={PROC_PACK_OPEN_YOUNG}
                    />
                    {legalConfirmationSection}
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HirePackOpenYoungStep1.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func,
    gestorCrossEnabled: PropTypes.bool,
    hireCmsKey: PropTypes.string.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HirePackOpenYoungStep1;
